module.exports = __webpack_public_path__ + "static/media/XMasFeier2025.81f84a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/XMasFeier2025.jpg
// module id = 331
// module chunks = 0